export const PROFILE_TAB = 'Profile';
export const EMBED_TAB = 'Embed';
export const API_TAB = 'API';
